<template>
  <div v-if="currentGrant || livePreviewHash">
    <grants />
  </div>
</template>
<script setup lang="ts">
import { useAsyncData } from '#app';
import { useRoute } from 'vue-router';
import { useLivePreview } from '~/composables/live-preview';
import { useGrantsStore } from '~/stores/grants';
import Grants from '~/components/templates/Grants.vue';
import { DEFAULT_LAYOUT } from '~/constants/layout';
import { useEntryPasswordProtected } from '~/composables/entry-password-protected';

const route = useRoute();
const grantsStore = useGrantsStore();
const { checkEntry, redirect } = useEntryPasswordProtected();
const { getLivePreviewHashFromPath, handleLivePreviewMode } = useLivePreview();
const livePreviewHash = getLivePreviewHashFromPath(route);

const { data: currentGrant } = await useAsyncData(
  route.path,
  async () => {
    return await grantsStore.loadSingle(route.params.slug as string);
  },
  {
    watch: [route],
  }
);

if (!currentGrant.value) {
  const { data: isProtectedPage } = await useAsyncData(
    `path-protected-${route.path}`,
    async () => {
      return checkEntry(route.path, 'grants');
    },
    {
      watch: [route],
    }
  );

  if (isProtectedPage.value) {
    await redirect('grants', livePreviewHash);
  } else {
    if (!livePreviewHash) {
      showError({
        statusCode: 404,
        statusMessage: 'Page not found',
      });
    }
  }
}

grantsStore.setGrant(currentGrant.value);

onMounted(() => {
  handleLivePreviewMode(livePreviewHash);
});

onBeforeUnmount(() => {
  if (route.name === 'grants-slug') {
    return;
  }

  grantsStore.setCurrentGrant(null);
});

definePageMeta({
  key: (route) => route.fullPath,
  pageType: 'grant',
  layout: DEFAULT_LAYOUT,
});
</script>
